const React = require("react");
const Routes = require("idam-web-ui");

class PageCase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isTwoFactorAuthorizationEnabled: false,
    };
  }

  checkIfAccessTokenExists() {
    const accessToken = window.localStorage.getItem("access_token_lp2");
    this.setState({
      isTwoFactorAuthorizationEnabled: !!accessToken,
    });
  }

  componentDidMount() {
    this.checkIfAccessTokenExists();
  }

  detectIfScreenIsMobile() {
    if (
      (window.innerWidth <= 600 && window.innerHeight <= 800) ||
      this.checkIfScreenIsTouchable()
    ) {
      return true;
    }
    return false;
  }

  checkIfScreenIsTouchable() {
    const match = window.matchMedia || window.msMatchMedia;
    if (match) {
      const mq = match("(pointer:coarse)");
      return mq.matches;
    }
    return false;
  }

  render() {
    const Mobile2FAApplication = Routes.default;

    const { isTwoFactorAuthorizationEnabled } = this.state;
    const className = this.props.isLoginPreferencesView ? "" : "pagecontent";
    const isMobile = this.detectIfScreenIsMobile();
    let spacingHeaderClass = this.props.headerSpacing ? this.props.headerSpacing : "";

    if (isMobile && isTwoFactorAuthorizationEnabled) {
      return (
        <React.Fragment>
          <Mobile2FAApplication />
        </React.Fragment>
      );
    }

    return (
      <div
        style={{
          minHeight: "100%",
          position: "relative",
        }}
      >
        {this.props.header}
        <div className={`loginwidgetBody ${spacingHeaderClass}`}>
          <div className="container-fluid extra-container">
            <div className={className}>{this.props.content}</div>
          </div>
        </div>
        {this.props.footer ? this.props.footer : null}
      </div>
    );
  }
}

module.exports = PageCase;
